import * as React from 'react';

import { Modal } from '../../../../../Modal';
import { TaxDeduction } from "../../../../../TaxDeduction";
import * as main from '../../../styles/main.module.scss';
import * as hero from './hero.module.scss';

export const Hero = ({ buttonText, modal, widget }) => {
  const [isModal] = React.useState(modal);
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={hero.hero}>
      <div className={'container'}>
        <div className={hero.hero__container}>
          <div className={hero.hero__titleWrapper}>
            <h1 className={hero.hero__title}>
              <span className={hero.hero__titleLarge}>«Учись Учиться» —</span>
              <br />
              онлайн-курс для когнитивного развития ребенка
            </h1>
            <ul className={hero.hero__list}>
              <li className={hero.hero__item}>Повышает эффективность обучения и&nbsp;мотивацию учиться.</li>
              <li className={hero.hero__item}>
                Помогает развить навыки и&nbsp;качества, важные для успеха в&nbsp;будущем.
              </li>
              <li className={hero.hero__item}>Для учащихся 8—11&nbsp;классов.</li>
            </ul>
          </div>
          <div className={`row ${hero.hero__infoWrapper}}`}>
            <div className={`col-12 col-md-6`}>
              <p className={hero.hero__text}>Рекомендован Навигатором образования Минпросвещения РФ и Смартекой</p>
              <div className={hero.hero__imageWrapper}>
                <div className={hero.hero__imgContainer}>
                  <img
                    src={'https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/minpros_hd.png'}
                    alt={'Минпросвещения России'}
                  />
                </div>
                <div className={hero.hero__imgContainer}>
                  <img
                    src={'https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/smarteka.png'}
                    alt={'Смартека'}
                  />
                </div>
              </div>
            </div>
            <div className={`col-12 col-md-6 ${hero.hero__infoColSecond}`}>
              <img
                src={'https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/nya.png'}
                alt={'Николай Ягодкин'}
              />
              <p className={hero.hero__text}>Автор методики Николай Ягодкин</p>
            </div>
          </div>
          <div className={hero.hero__linkWrapper}>
            {isModal ? (
              <button
                className={main.mainBtn}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                {buttonText}
              </button>
            ) : (
              <a className={main.mainBtn} href={'#user-action'}>
                {buttonText}
              </a>
            )}
            <TaxDeduction margin={"30px 0 0"}/>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
